export default __webpack_public_path__ + "static/media/minus.56b6ab14.svg";